import "./styles/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Analytics from "./utils/Analytics";
import MainPage from "./pages/main/MainPage";
import DdayPage from "./pages/dday/DdayPage";
import ContactPage from "./pages/contact/ContactPage";
import NotFoundPage from "./pages/main/NotFoundPage";

function App() {
  return (
    <div>
      <BrowserRouter>
        <Analytics />
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/dday" element={<DdayPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
